import { sendGTMEvent } from '@next/third-parties/google';

/**
 * Push data to GTM's data layer
 * @param data Object
 */
export const pushToDataLayer = (data: object) => {
  sendGTMEvent(data);
};
